












import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import TipoTramiteComponentProp from "@/helpers/tipoTramiteComponentProp.helper";
import { PropOptions } from "vue";
import Miembro from "../../models/miembro/miembro.model";
import BTableConfig from "@/core/BTableConfig/BTableConfig";
import { Utils } from "@/core/Utils";

@Component
export default class ComposicionFamiliarTable extends BaseVue {
  @Prop() readonly hogarId!: number;
  @Prop() readonly codigoHogar!: string;
  @Prop() readonly titulo!: string;

  miembroTableConfig: BTableConfig<Miembro> | null = null;
 
  constructor() {
    super();
  }
  created() {
    let props = [];
    props.push(
     // new TipoTramiteComponentProp("hogarId", "number"),
      new TipoTramiteComponentProp("codigoHogar", "string"),
        new TipoTramiteComponentProp("titulo", "string",false,"Título")
    );
    this.$emit("render", props);
  }
 
  onLoadTable(config: BTableConfig<Miembro>) {
    this.miembroTableConfig = config;
  }
}
